import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../../common/hooks/hooks";
import { TransformedProduct } from "../../../types/productApiTypes";
import { openProductModal } from "../../common/ProductModal/productModalSlice";
import CardActions from "../../common/ProductCard/CardActions";
import WishlistToggleButton from "../../../../wishlist/components/common/WishlistToggleButton";
import CompareToggleButton from "../../../../compare/components/common/CompareToggleButton";
import ProductPriceDisplay from "../../common/ProductPriceDisplay";

interface ProductPanelItemProps {
  product: TransformedProduct;
  onItemClick: () => void;
  showStockStatus?: boolean;
}

const ProductPanelItem: React.FC<ProductPanelItemProps> = ({
  product,
  onItemClick,
  showStockStatus = false,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // UPDATED: Use mainImage directly instead of legacy array
  const image = product.mainImage;

  const handleQuickViewClick = (productId: number) => {
    dispatch(openProductModal({ productId }));
  };

  // Stock Status Logic
  const stockLabel =
    product.stockStatus === "outofstock"
      ? t("productCard.outOfStockBadge", "Sold Out")
      : t("productInfoDetails.inStock", "In Stock");

  const stockClass =
    product.stockStatus === "outofstock" ? "is-out-of-stock" : "is-in-stock";

  // --- BUY X PAY Y PROMOTION LOGIC ---
  const promo = product.buyXPayYPromotion;
  const showPromoBadge =
    promo?.isEligible && product.stockStatus !== "outofstock";

  return (
    <li className="product-panel-item">
      <div className="product-panel-item__top-actions">
        <WishlistToggleButton
          productId={product.id}
          className="product-panel-item__toggle-btn"
        />
        <CompareToggleButton
          productId={product.id}
          className="product-panel-item__toggle-btn"
        />
      </div>
      <div className="product-panel-item__image">
        <a href={product.permalink} onClick={onItemClick}>
          {image ? (
            <img src={image.thumbnail} alt={image.alt || product.name} />
          ) : (
            <div className="placeholder-image"></div>
          )}
        </a>
      </div>
      <div className="product-panel-item__content">
        <div className="product-panel-item__details">
          <a
            href={product.permalink}
            className="product-panel-item__name"
            onClick={onItemClick}
          >
            {product.name}
          </a>

          {showPromoBadge && (
            <span className="cart-item-promo-badge">
              {t("productCard.buyXPayYBadge", {
                buy: promo.buyQty,
                pay: promo.payQty,
                defaultValue: `Buy ${promo.buyQty} Pay ${promo.payQty}!`,
              })}
            </span>
          )}

          <ProductPriceDisplay
            product={product}
            className="product-panel-item__price"
          />
          {showStockStatus && (
            <span className={`product-panel-item__stock-status ${stockClass}`}>
              {stockLabel}
            </span>
          )}
        </div>
        <div className="product-panel-item__actions">
          <CardActions
            product={product}
            onQuickViewClick={handleQuickViewClick}
          />
        </div>
      </div>
    </li>
  );
};

export default ProductPanelItem;
